module.exports = __webpack_public_path__ + "img/9-small.739297c3.png";